import React from 'react'
import './loadingSnipper.scss';

function LoadingSnipper() {
    return (
        <div className='loading-spinner'></div>
    )
}

export default LoadingSnipper